import { Injectable } from '@angular/core';
import { ELEMENTS, ZONES_TYPES } from 'src/app/data/elements';
import { Element } from 'src/app/model/element';
import { Subject } from 'rxjs';
import { CANVAS_COLORS } from '../data/canvas-colors';
import { ZonesPropertiesService } from './zones-properties.service';
import { identifierModuleUrl } from '@angular/compiler';
import { SCALE } from '../data/scale'; 
import {polygon} from 'polygon-tools';

@Injectable({
  providedIn: 'root'
})
export class ElementsService {

  private _elementsSource: Subject<Element[]> = new Subject();
  private _currentElements: Element[];
  elements$ = this._elementsSource.asObservable();
  elementIndex=1;

  constructor(
    private zonesPropertiesService: ZonesPropertiesService
    ) {
    this._currentElements=ELEMENTS;
  }

  get elementSource(): Subject<Element[]> {
    return this._elementsSource;
  }
  set elementSource(data: Subject<Element[]>) {
    this._elementsSource = data;
  }

  get currentElements(): Element[] {
    return this._currentElements;
  }
  set currentElements(elements: Element[]) {
    this._currentElements = elements;
  }

  getNumberOfElements(type:string){
    return this.currentElements[type].length;
  }


  getContour(id:number=0){
    return this.getElement('contour',id);
  }

  getZone(id:number){
    return this.getElement('zones',id);
  }

  getZones(){
    return this.getElements('zones');
  }
  getElements(type:string){
    return this.currentElements[type];
  }

  getContourPoints(id:number=0){
    
    return this.getElement('contour',id).points;
  }

  getZonePoints(id:number){
    return this.getElementById('zones',id).points;
  }

  getElement(type:string,id:number){
    return this.currentElements[type][id]
  }
  getContourId(){
    return this.getElements('contour')[0].id
  }
  addContour(){
    return this.addElement('contour',CANVAS_COLORS['DRAW-CONTOUR']);
  }

  addZone(){
    // let element=this.addElement('zones',this.getRandomColor())
    let element=this.addElement('zones',null)
    this.zonesPropertiesService.addZone(element)   
    return element.id;
  }

  removeElementPointById(type:string,layer:number,id:number){
    let index=this.getElementIndexById(type,layer)
    this._currentElements[type][index].points.splice(id,1)

    this.elementSource.next(this._currentElements);
  }

  removeZoneById(id:number){
    let properties=this.zonesPropertiesService.removeZoneProperty(id)
    this.removeElementById('zones',id)
    return properties
  }

  removeElementById(type:string,id:number){
    let index=this.getElementIndexById(type,id);
    this._currentElements[type].splice([index],1)

    this.elementSource.next(this._currentElements);
  }

  getZoneById(id:number){
    return this.getElementById('zones',id);
  }

  getElementById(type:string,id:number){
    for(let i=0;i<this.currentElements[type].length;i++){
      if(this.currentElements[type][i].id==id)
        return this.currentElements[type][i]
    }
  }

  getElementIndexById(type:string,id:number){
    for(let i=0;i<this.currentElements[type].length;i++){
      if(this.currentElements[type][i].id==id)
        return i
    }
  }

  putZoneOnIndex(zone,index){
    this.currentElements['zones'].splice(index, 0, zone);
    this.elementSource.next(this.currentElements);
  }

  comparePoints(point1, point2):boolean{
    if(point1.x==point2.x && point1.y==point2.y)
      return true;
    else
      return false;
  }

  addElement(type:string, color:string){
    let id=this.elementIndex++//this.getHighestId(type)+1
    if(color==null)
      if(CANVAS_COLORS['ZONE-ROOF'][id]!=undefined)
        color=CANVAS_COLORS['ZONE-ROOF'][id];
      else
        color=this.getRandomColor();
    
    let element={
      id:id,
      points : [],
      color: color,      
      type:0
    }
    this._currentElements[type].push(element)
    this.elementSource.next(this._currentElements);
    return element;
  }

  getHighestId(type:string){
    let id:number=0;
    for(let i=0;i<this.currentElements[type].length;i++){
      if(this.currentElements[type][i].id>id){
        id=this.currentElements[type][i].id;
      }
    }
    return id;
  }

  checkIfShapeClosed(element){
    // let shape=this.getElementById(type,id);
    if(element.points.length>2)
      if(!this.comparePoints(element.points[0],element.points[element.points.length-1])){
        return false      
      }else{
        return true
      }
    else
      return false;
    
  }

  checkIfShapesClosed(){
    let closed=true;

    if(!this.comparePoints(this.currentElements['contour'][0].points[0],this.currentElements['contour'][0].points[this.currentElements['contour'][0].points.length-1])){
      closed=false
    }
    for(let i=0;i<this.currentElements['zones'].length;i++){
      if(!this.comparePoints(this.currentElements['zones'][i].points[0],this.currentElements['zones'][i].points[this.currentElements['zones'][i].points.length-1])){
        closed=false
        break;
      }
    }
    return closed;
  }

  getRandomColor() {
    var color = Math.floor(0x1000000 * Math.random()).toString(16);
    return '#' + ('000000' + color).slice(-6);
  }

  clearInvalidZones():boolean{
    this.calculateAreas();
    let deleted:boolean=false;
    let deletedIds=[];
    let zones=this.currentElements['zones']
    let len=zones.length-1
    for(let i=len;i>=0;i--){
      if(parseFloat(zones[i].area)==0){
        // zones.splice(i,1);
        deletedIds.push(zones[i].id)
        // deleted=true;
      }
    }
    if(deletedIds.length>0){
      deleted=true;
      for(let i=0;i<deletedIds.length;i++){
        this.removeZoneById(deletedIds[i]);
      }
    }
    return deleted;
  }
  /**
   * Funkcje liczace obszar
   */

  calculateAreas(){
    let contour=this.getContour();
    let zones= this.getZones();
    let metersPerPx=SCALE.screen.default.metersPerPx
    if(contour){
      contour.area= Math.abs(polygon.area(this.formatPoints(contour.points))*metersPerPx*metersPerPx).toFixed(2);
      // contour.area=this.calculateArea(contour.points);
    }

    for(let i=0;i<zones.length;i++){
      zones[i].area= Math.abs(polygon.area(this.formatPoints(zones[i].points))*metersPerPx*metersPerPx).toFixed(2);
      // zones[i].area=this.calculateArea(zones[i].points);
    }
    if(zones.length>=2){
      let areaCoveredBy={};
      for(let i=0;i<zones.length;i++){
        for(let j=0;j<zones.length;j++){
          if(zones[i].id==zones[j].id)
            continue;

            if(!this.ifOutside(zones[i],zones[j])){
              let down,top;
              if(i<j){
                down=i;
                top=j
              }else{
                down=j;
                top=i
              }

              if(areaCoveredBy[down]==undefined){
                areaCoveredBy[down]=[]
              }
              if(areaCoveredBy[down].indexOf(top)<0){
                areaCoveredBy[down].push(top)
              }
            }
        }
      }
      let overlappingAreas=Object.entries(areaCoveredBy)
      console.log(overlappingAreas)
      // this.substractAreas() 
      for(let i=0;i<overlappingAreas.length;i++){
        this.substractAreas(overlappingAreas[i][0],overlappingAreas[i][1])
      }
    }
  }

  substractAreas(baseZone,topZones){
    console.log(baseZone,topZones)
    let zone= this.getZone(baseZone)
    let metersPerPx=SCALE.screen.default.metersPerPx
    let baseZonePoints=this.formatPoints(zone.points);
    let baseZonePointsArea=baseZonePoints,baseZonePointsHoles=[];
    let holesArea,holesAreaPoints;
    // Signed area - 2D only
    let area:number = 0
    let topZonesFormated=[]
    topZonesFormated.push(baseZonePoints);
    for(let i=0;i<topZones.length;i++){      
      let topZone= this.getZone(topZones[i])
      let topZonePoints=this.formatPoints(topZone.points);
      topZonesFormated.push(topZonePoints)
      if(baseZonePointsArea){
        baseZonePoints = polygon.subtract(baseZonePointsArea, topZonePoints);
        if(baseZonePoints.length>1){
          baseZonePointsArea=baseZonePoints[1];
          baseZonePointsHoles.push(baseZonePoints[0])
        }else{
          baseZonePointsArea=baseZonePoints[0];
        }
      }
        
    }
    if(baseZonePointsArea){
      area = Math.abs(polygon.area(baseZonePointsArea));
      area=Math.round(area*metersPerPx*metersPerPx*100)/100;
    }
    if(baseZonePointsHoles.length>0){
      console.log(baseZonePointsHoles)
      holesAreaPoints = polygon.union.apply(this,baseZonePointsHoles);
      for(let i=0;i<holesAreaPoints.length;i++){
        holesArea = Math.abs(polygon.area(holesAreaPoints[i]))
        holesArea =Math.round(holesArea*metersPerPx*metersPerPx*100)/100;
        area=area-holesArea;
      }
      
    }    
    zone.area=Math.round(area*100)/100;
    // zone.area=(area*metersPerPx*metersPerPx).toFixed(2);
    
  }

  formatPoints(points){
    let formatedPoints=[]
    for(let i=0;i<points.length;i++){
      formatedPoints.push([points[i].x,points[i].y])
    }

    return formatedPoints;
  }

  ifOutside(zone1,zone2){
    let zone1X=this.getMinMax(zone1.points,'x')
    let zone1Y=this.getMinMax(zone1.points,'y')
    let zone2X=this.getMinMax(zone2.points,'x')
    let zone2Y=this.getMinMax(zone2.points,'y')

    if(
      (zone1X.min>=zone2X.max && zone1X.min>=zone2X.min) ||
      (zone1X.max<=zone2X.min && zone1X.min<=zone2X.min) ||
      (zone1Y.max<=zone2Y.min && zone1Y.min<=zone2Y.min) ||
      (zone1Y.min>=zone2Y.max && zone1Y.min>=zone2Y.min)
      )

      return true;
    
    else
      return false;

  }

  getMinMax(setOfPoints,axis){
    let min=null;
    let max=null;
    for(let i=0;i<setOfPoints.length;i++){
      if(min==null || min>setOfPoints[i][axis])
        min=setOfPoints[i][axis];
      
      if(max==null || max<setOfPoints[i][axis])
        max=setOfPoints[i][axis];
    }

    return {min:min,max:max};
  }


  calculateArea(points){
    let arrays=this.createCoordsArrays(points);
    
    let a = this.polygonArea(arrays.x, arrays.y, points.length-1);
    
    return a;
  }

  createCoordsArrays(points){
    let x=[];
    let y=[];
    
    //pomija ostatni punkt bo ostatni jest zamykajacy a wiec taki sam jak pierwszy
    for(let i=0;i<points.length-1;i++){
      x.push(points[i].x)
      y.push(points[i].y)
    }

    return {x:x,y:y}
  }

  polygonArea(X, Y, numPoints) 
  { 
    let area = 0;         // Accumulates area in the loop
    let j = numPoints-1;  // The last vertex is the 'previous' one to the first
  
    for (let i=0; i<numPoints; i++)
      { area = area +  (X[j]+X[i]) * (Y[j]-Y[i]); 
        j = i;  //j is previous vertex to i
      }
    return Math.abs(Math.round((area/2)*(SCALE.screen.default.metersPerPx*SCALE.screen.default.metersPerPx)*100)/100);
  }



  
}
